import { Branch } from '@/api/model/branch'
import { BaseModel } from '@/api/base-model'
import { BranchTargetAPI } from '@/api/backend-client'
import { Pipeline } from '@/api/model/pipeline'

export class BranchTarget extends BaseModel<BranchTarget> {
    protected collectionName = BranchTargetAPI.collectionName

    constructor(
        public branch: Branch|null,
        public id: string,
        public fromDate: Date,
        public untilDate: Date,
        public referralPipeline: Pipeline|null,
        public referralType: string,
        public orderType: string,
        public direction: string,
        public quantity: number,
        public turnover: number,
        public createdAt: Date|null,
        public updatedAt: Date|null,
    ) { super(id) }

    static fromData(data: any): BranchTarget {
        if (data === null || typeof data === 'string' || data instanceof BranchTarget) {
            return data
        }

        return new BranchTarget(
            data.branch ? Branch.fromData(data.branch) : null,
            data.id,
            data.fromDate,
            data.untilDate,
            data.referralPipeline ? Pipeline.fromData(data.referralPipeline) : null,
            data.referralType,
            data.orderType,
            data.direction,
            data.quantity,
            data.turnover,
            data.createdAt,
            data.updatedAt,
        )
    }
}
